export default "__VITE_ASSET__Bft0TSpj__"